var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 91,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.4%",
    y: "-3.7%",
    width: "108.8%",
    height: "110.4%",
    filterUnits: "objectBoundingBox",
    id: "icon-calculator_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-calculator_svg__a)",
    transform: "translate(-117 -62)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 142c0 2.21-17.91 4-40 4-22.093 0-40-1.79-40-4s17.907-4 40-4c22.09 0 40 1.79 40 4",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 133c0 2.2-1.833 4-4.073 4h-48.856c-2.24 0-4.071-1.8-4.071-4V71c0-3.203.831-4 4.071-4h48.856c3.24 0 4.073.797 4.073 4v62z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 137.584c0 3.437-.823 4.416-4.072 4.416h-48.856c-3.249 0-4.072-.979-4.072-4.416V89h57v48.584z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 101c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM158 101c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM171 101a3 3 0 01-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM183 101c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM183 110c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM146 110c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM158 110c0 1.658-1.343 3-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM171 110a3 3 0 01-3 3h-2a3 3 0 110-6h2a3 3 0 013 3zM146 120c0 1.658-1.343 3-3 3h-2a3 3 0 010-6h2a3 3 0 013 3zM158 120c0 1.658-1.343 3-3 3h-2a3 3 0 010-6h2a3 3 0 013 3zM171 120a3 3 0 01-3 3h-2a3 3 0 010-6h2a3 3 0 013 3zM146 130c0 1.658-1.343 3-3 3h-2a3 3 0 010-6h2a3 3 0 013 3zM158 130c0 1.658-1.343 3-3 3h-2a3 3 0 010-6h2a3 3 0 013 3zM171 130a3 3 0 01-3 3h-2a3 3 0 010-6h2a3 3 0 013 3z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 129a4 4 0 01-8 0v-7.999a4.001 4.001 0 014-4.001c2.208 0 4 1.792 4 4.001v8zM181.295 83h-41.59c-.942 0-1.705-.746-1.705-1.667v-6.666c0-.92.763-1.667 1.705-1.667h41.59c.942 0 1.705.746 1.705 1.667v6.666c0 .92-.763 1.667-1.705 1.667z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconCalculator;